import { RequestProps, Role } from '../../types'
import { apiSlice } from '../api/apiSlice'
import RoleDetailsResponse from "../../types/response/RoleDetailsResponse";
import { PermissionLight } from "./permissionsSlice";

export type RoleDetails = {
  id: string
  name: string
  createdAt: Date
  modifiedAt: Date
  permissions: PermissionLight[]
  employees: EmployeeFullName[]
}
export type EmployeeFullName = {
  id: string
  firstName: string
  lastName: string
}

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRoles: builder.query<Role[], RequestProps>({
      query: (props: RequestProps) => ({
        url: 'roles',
        params: props,
      }),
      providesTags: () => [{ type: 'Role', id: 'LIST' }],
    }),

    getRolesDetailed: builder.query<RoleDetailsResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: 'roles/details',
        params: props,
      }),
      providesTags: () => [{ type: 'Role', id: 'LIST' }],
    }),
  }),
})

export const { useGetRolesQuery, useGetRolesDetailedQuery } = extendedApiSlice
